import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import ForgotPassword from "./Pages/ForgotPassword";
import PostCreationPage from "./Pages/PostCreationPage";
import SavedPost from "./Pages/SavedPost";
import Search from "./Pages/Search";
import UserProfile from "./Pages/UserProfile";
import axios from "axios";

function App() {
  const [authStatus, setAuthStatus] = useState(false);

  useEffect(() => {
    // Check if auth token exists in local storage
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      setAuthStatus(true); // User is authenticated
    } else {
      setAuthStatus(false); // User is not authenticated
    }
  }, [authStatus]); // Add authStatus as a dependency

  const [locality, setLocality] = useState("");

  const reverseGeocode = async (lat, lon) => {
    const url = `https://trueway-geocoding.p.rapidapi.com/ReverseGeocode?location=${lat}%2C${lon}&language=en`;
    const options = {
      method: "GET",
      headers: {
        "content-type": "application/octet-stream",
        "X-RapidAPI-Key": "ba59e3bf2emsh3d7932036ffad4bp152774jsn37e1f2517565",
        "X-RapidAPI-Host": "trueway-geocoding.p.rapidapi.com",
      },
    };

    const response = await fetch(url, options);
    const data = await response.json();
    const locality = data["results"][0]["locality"];
    //console.log(locality);
    localStorage.setItem("location", locality);
    return locality;
  };

  // const getHotels = (locality) => {
  //   // Implement your logic to get hotels based on the locality
  //   // ...
  // };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const showPosition = (position) => {
      const lat = position.coords.latitude;
      const lon = position.coords.longitude;

      //console.log("Latitude: " + lat + " Longitude: " + lon);

      reverseGeocode(lat, lon)
        .then((locality) => {
          //console.log(locality);
          setLocality(locality);
        })
        .catch((error) => console.error(error));
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const token = localStorage.getItem("authToken");

  if (token) {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          "https://foodie-wirte.onrender.com/api/protected",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const { name } = response.data;

        const u_name = name
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        localStorage.setItem("currentUserName", u_name);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }

  // const [currentLocation, setCurrentLocation] = useState({
  //   currLocation: "",
  //   lat: "",
  //   lon: "",
  // });

  // useEffect(() => {
  //   getLocation();
  // }, []);

  // const getLocation = async () => {
  //   const location = await fetch("https://ipapi.co/json");
  //   const data = await location.json();
  //   console.log(data);
  //   setCurrentLocation({
  //     currLocation: data.city,
  //     lat: data.latitude,
  //     lon: data.longitude,
  //   });
  // };

  return (
    <div className="app">
      <Router>
        <Routes>
          {authStatus ? (
            <Route path="/" element={<Home locality={locality} />} />
          ) : (
            <Route path="/" element={<Login />} />
          )}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/reset-password" element={<ForgotPassword />} />
          <Route
            path="/create-post"
            element={<PostCreationPage location={locality} />}
          />
          <Route path="/saved-post" element={<SavedPost />} />
          <Route path="/search" element={<Search />} />
          <Route path="/user-profile" element={<UserProfile />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
